import { useState, useEffect } from 'react';
import useHasAccess from './useHasAccess';

function usePermission(permission) {
  const [isAllowed, setIsAllowed] = useState(false);

  const { isAllowed: allowed } = useHasAccess({ permission });

  useEffect(() => {
    setIsAllowed(allowed);
  }, [allowed]);

  return isAllowed;
}

export default usePermission;